import { render, staticRenderFns } from "./EditAddress.vue?vue&type=template&id=34c98778&scoped=true&"
import script from "./EditAddress.vue?vue&type=script&lang=js&"
export * from "./EditAddress.vue?vue&type=script&lang=js&"
import style0 from "./EditAddress.vue?vue&type=style&index=0&id=34c98778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c98778",
  null
  
)

export default component.exports